export enum OrderType {
  client = 1,
  simplified = 2,
  tour = 3,
  transmission = 4,
}
